import React, { Dispatch, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import { ApplicationState } from '../../../../store';
import { StarFilled } from '@ant-design/icons';
import { ListInscricoesEstaduais } from './styles';
import { FavoriteServices } from './services/favoriteServices';
import { profileUpdateRequest } from '../../../../store/ducks/auth/actions';
import { Spin } from 'antd';

const TableFavoritos: React.FC = () => {
  const user = useSelector((state: ApplicationState) => state.auth.user);
  const dispatch = useDispatch<Dispatch<Action>>();
  const [loading, setLoading] = useState(false);

  const activeFavorite = async (codParceiro: number, favorito: boolean) => {
    try {
      setLoading(true);
      await FavoriteServices.favoritaInscricaoEstadual(codParceiro, !favorito);
    } catch (error) {
    } finally {
      const data = document.getElementById(`${codParceiro}`);
      data?.classList.toggle('activeStar');
      dispatch(profileUpdateRequest({ nome: user?.nome ?? '' }));
      setLoading(false);
    }
  };

  return (
    <>
      <ListInscricoesEstaduais>
        {user?.inscricoesEstaduais?.map((inscData) => (
          <li
            className={inscData.isFavorito ? 'activeStar' : ''}
            key={inscData.codParceiro}
            id={`${inscData.codParceiro}`}
          >
            {loading ? (
              <Spin size="small" />
            ) : (
              <span onClick={() => activeFavorite(inscData.codParceiro, inscData.isFavorito)}>
                <StarFilled style={{ fontSize: '18px' }} />
              </span>
            )}
            <span>
              <strong>Nome:</strong> {inscData.nomeParceiro} - <strong>Código:</strong> {inscData.codParceiro}
              <br />
              <strong>Inscrição estadual:</strong> {inscData.inscricaoEstadual}
            </span>
          </li>
        ))}
      </ListInscricoesEstaduais>
    </>
  );
};

export default TableFavoritos;
